import { Box, Button, IconButton, Tab, Tabs } from "@mui/material";
import { showError } from "../../helpers/showToast";
import MainContainer from "layout/MainContainer";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyPartnerDetailsQuery } from "service/partner";
import { Partner } from "types/General";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PartnerDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [getDetail] = useLazyPartnerDetailsQuery();
  const [valueTabs, setValueTabs] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [partnerData, setPartnerData] = useState<Partner>();

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const getUserDetails = async (id: string) => {
    setLoading(true);
    try {
      const response = await getDetail({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setPartnerData(response?.data);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getUserDetails(id);
    }
  }, []);

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>Partner Details</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Manage Partners - Partner Details
          </p>
        </div>

        <div className="right_s align_right">
          <Button className="btn btn_orange" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <Box className="custom_tabs2" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
          <Tab label="Partner Information" {...a11yProps(0)} />
          <Tab label="Documents" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <div>
            <div className="profileInfo_head">
              <h2>User Information</h2>
            </div>
            <div className="profileInfo_list">
              <ul className="text_info gap_p">
                <li className="w_50">
                  <strong>Name</strong>
                  <span>{partnerData?.partnerName || "-"}</span>
                </li>
                <li className="w_50">
                  <strong>E-mail</strong>
                  <span>{partnerData?.partnerEmail || "-"}</span>
                </li>
                <li className="w_50">
                  <strong>Phone</strong>
                  <span>{`${partnerData?.countryCode} 45344353`}</span>
                </li>

                <li className="w_50">
                  <strong>License</strong>
                  <span>{partnerData?.licenseNumber}</span>
                </li>
              </ul>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div>
            {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ width: "40%" }}>
                <div className="profileInfo_head">
                  <h2>Passport</h2>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  {[1, 2].map((img, index) => (
                    <img
                      key={index}
                      src={"/static/images/residence_attachment.jpg"}
                      alt={`Car ${index}`}
                      style={{
                        width: "50%",
                        objectFit: "contain",
                        cursor: "pointer",
                        borderRadius: "8px",
                        flexShrink: 0,
                      }}
                    />
                  ))}
                </div>
              </div>
              <div style={{ width: "40%" }}>
                <div className="profileInfo_head">
                  <h2>UAE Driving License</h2>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  {[1, 2].map((img, index) => (
                    <img
                      key={index}
                      src={"/static/images/residence_attachment.jpg"}
                      alt={`Car ${index}`}
                      style={{
                        width: "50%",
                        objectFit: "contain",
                        cursor: "pointer",
                        borderRadius: "8px",
                        flexShrink: 0,
                      }}
                    />
                  ))}
                </div>
              </div>
            </div> */}
          </div>
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default PartnerDetails;
